<template>
    <div class="business">
        <div class="title">主营业务</div>
        <div class="tips">帮助您更加了解互相联水族用品</div>

        <div class="business-content">
            <div class="business-desc">
                销售批发鱼缸水族，海鲜池专用配件，鱼缸配件，水族器材用品(水族过滤材料，水泵气泵),广泛应用在：海鲜鱼缸，生超鱼缸，观赏鱼缸，假山喷漆等领域!<br/><br/>
                1:水泵：山野、佳宝、森森、凌霄，海利博宇等品牌。<br/>
                2:气泵：静音龟泵，鼓风式风机，电磁泵。<br/>
                3:鱼缸专用增氧，溢水，排水，砂头配件。<br/>
                4:过滤海绵，黄棉，白棉，绿棉，蓝棉，黑棉等。<br/>
                5:PVC水管，弯头，开关，直通，三通，活接等。<br/><br/>
                并取得了较好的经济效益和社会效益，赢得了行业和客户的赞誉和推崇。<br/>
            </div>
            <img src="../assets/image/bg_2.webp" class="vue-lazy">
        </div>
    </div>
</template>

<script>
export default {
    name: 'BusinessComp'
}
</script>

<style scoped lang="scss">
.business {
    padding: 40px 20px;

    @media (min-width: 768px) {
        padding: 80px;
    }
    box-sizing: border-box;
    width: 100%;

    .title {
        color: #000000;
        font-family: "Inter";
        font-size: 24px;
        animation: animate__fadeInUp 0.8s ease-in-out;

        @media (min-width: 768px) {
            font-size: 30px;
        }
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
        text-align: center;
        margin-bottom: 18px;
    }

    .tips {
        color: #4B5563;
        font-family: "Inter";
        font-size: 14px;
        line-height: 1.8;
        animation: animate__fadeInUp 0.8s ease-in-out 0.2s;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        margin-bottom: 50px;
    }

    .business-content {
        display: flex;
        flex-direction: column;
        gap: 24px;

        @media (min-width: 768px) {
            flex-direction: row;
            justify-content: space-between;
            gap: 48px;
        }
        align-items: center;
        gap: 48px;

        .business-desc {
            flex: 1 1 50%;
            color: #4B5563;
            font-family: "Inter";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
        }

        img {
            width: 100%;
            max-width: none;
            margin-bottom: 30px;
            animation: animate__fadeInUp 1s ease-in-out;
            box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.3);

            @media (min-width: 768px) {
                flex: 1 1 50%;
                max-width: 45%;
                margin-bottom: 0;
            }
            border-radius: 10px;
        }
    }
}
</style>